import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy } from "core";
import DateHelper from "core/DateHelper";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericDateInput, GenericGrid, GenericSelectInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import { GridColumnType, ProgramCodes } from "views/Constants/Constant.js";
import ClientHelper from "core/ClientHelper";

class GetCollectionReport extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			model: {},
			isLoading: false,
			TxnDetail: {},
			IsTxnDetailOpen: false
		};

		this.ValueChanged = this.ValueChanged.bind(this);
		this.ClearClick = this.ClearClick.bind(this);
		this.SearchClick = this.SearchClick.bind(this);
	}

	componentDidMount() {
		const { setAppLeftTitle, setAppCenterTitle } = this.props;

		if (setAppLeftTitle)
			setAppLeftTitle("Collection Report");

		if (setAppCenterTitle)
			setAppCenterTitle("Reports");
	}

	ValueChanged(name, newValue) {
		this.setState(state => {
			var model = state.model || {};
			model[name] = newValue;

			return { model };
		});
	}

	ClearClick() {
		this.setState({ model: {} });
	}

	SearchClick() {
		const { showMessage } = this.props;

		this.setState({ isLoading: true });
		Proxy.POST(
			"/prepaidapi/v1.0/Wallet/GetCollectionReport",
			this.state.model,
			responseData => {
				this.setState({ isLoading: false });

				if (!responseData.IsSucceeded) {
					showMessage("error", "Error", responseData.ErrorDescription);
					return;
				}

				this.setState({ TransactionList: responseData.Item ?? [] });
			},
			error => {
				this.setState({ isLoading: false });
				showMessage("error", "Error", error);
			}
		);
	}

	render() {
		const { Disabled } = this.props;
		const { isLoading, alert, model, TransactionList } = this.state;
		var IsClient = ClientHelper.IsClient();

		return (
			<div>
				<LoadingComponent Show={isLoading} />
				{alert}

				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<ButtonToolbar ButtonList={[
							{ Code: "Clear", OnClick: this.ClearClick, Disabled: Disabled },
							{ Code: "Search", OnClick: this.SearchClick, Disabled: Disabled }
						]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />
						<Card>
							<CardHeader>
								<GenericTitle text={"Filter Panel"} />
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={3}>
										<GenericSelectInput
											Name="UniqueClientId"
											LabelText="Client"
											Method="POST"
											Url="/bankapi/v1.0/BankCustomer/Search"
											Parameter={{}}
											DataRoot="Item"
											KeyValueMember="Id"
											RenderItem={d => `${d.UniqueClientId} - ${d.Name}`}
											Value={model.UniqueClientId || ""}
											ValueChanged={this.ValueChanged}
											CanClear
											Disabled={IsClient}
											Required
											DefaultIndex={IsClient ? 0 : -1}/>
									</GridItem>
									<GridItem xs={3}>
										<GenericDateInput
											Name="FromDate"
											LabelText="From Date"
											Value={model.FromDate}
											ValueChanged={this.ValueChanged}
											Disabled={Disabled}
											MaxDate={model.FromDate || DateHelper.GetDate()}
											Utc
											Required />
									</GridItem>
									<GridItem xs={3}>
										<GenericDateInput
											Name="ToDate"
											LabelText="To Date"
											Value={model.ToDate}
											ValueChanged={this.ValueChanged}
											Disabled={Disabled}
											MinDate={model.ToDate}
											MaxDate={DateHelper.GetDate()}
											Utc
											Required />
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>

						<Card className="no-radius">
							<CardHeader>
								<GenericTitle text={"Transaction List"} />
							</CardHeader>
							<CardBody>
								<GridItem xs={12}>
									<GridItem>
										<GenericGrid
											Data={TransactionList}
											Columns={[
												{
													Header: "CardholderName",
													accessor: "CardholderName"
												},
												{
													Header: "StatementDate",
													accessor: "StatementDate",
													type: GridColumnType.DateTimeUtc,
												},
												{
													Header: "StatementDateTime",
													accessor: "StatementDateTime",
													type: GridColumnType.DateTimeUtc,
												},
												{
													Header: "StatementDueDate",
													accessor: "StatementDueDate",
													type: GridColumnType.DateTimeUtc,
												},
												{
													Header: "CardToken",
													accessor: "CardToken"
												},
												{
													Header: "StatementOwingBalance",
													accessor: "StatementOwingBalance",
													type: GridColumnType.Money,
												},
												{
													Header: "MinimumPaymentAmount",
													accessor: "MinimumPaymentAmount",
													type: GridColumnType.Money,
												},
												{
													Header: "OverdueBalance",
													accessor: "OverdueBalance",
													type: GridColumnType.Money,
												},
												{
													Header: "TotalRemainingBalance",
													accessor: "TotalRemainingBalance",
													type: GridColumnType.Money,
												},
												{
													Header: "PaymentAmount",
													accessor: "PaymentAmount",
													type: GridColumnType.Money,
												},
												{
													Header: "RevolvingPayment",
													accessor: "RevolvingPayment",
													type: GridColumnType.Money,
												},

												{
													Header: "NumberOfDelayDay",
													accessor: "NumberOfDelayDay"
												},
												{
													Header: "LoanType",
													accessor: "LoanType"
												},
												{
													Header: "PaymentStatus",
													accessor: "PaymentStatus"
												},
												// {
												// 	Header: "UniqueClientId",
												// 	accessor: "UniqueClientId"
												// },

											]}
											ShowPagination={true}
											/>
									</GridItem>
								</GridItem>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		);
	}

}

GetCollectionReport.propTypes = {
	Disabled: PropTypes.bool
};


export default GetCollectionReport;